module.exports = __webpack_public_path__ + "static/media/armandthiery1.e382ee99.jpg";